module.exports = __webpack_public_path__ + "916e963ca984b7ecffc38eb4aa9bce64.svg";